export default __webpack_public_path__ + "static/media/gridview_inactive.11ae0c49.svg";